import dateFormat from "dateformat";

const prettyDateSelect = $dateSelect => {

  const selectedRange = $dateSelect.val();

  $dateSelect.html(`
    <option value="24_hours">Last 24 Hours</option>
    <option value="today">Today</option>
    <option value="6_hours">Last 6 Hours</option>
    <option value="12_hours">Last 12 Hours</option>
    <option value="yesterday">Yesterday</option>
    <option value="this_week">This Week (Sun - Today)</option>
    <option value="7_days">Last 7 Days</option>
    <option value="last_week">Last Week (Sun - Sat)</option>
    <option value="this_month">This Month</option>
    <option value="30_days">Last 30 Days</option>
    <option value="last_month">Last Month</option>
    <option value="three_months">Last Three Months</option>
    <option value="custom">Custom</option>
  `);

  $dateSelect.val(selectedRange);

  if(window.innerWidth > 640) {

    switch (selectedRange) {
      case('today'):
        $dateSelect.find('option:selected').text(`Today: ${dateFormat(Date.now(), 'mmm dd, yyyy')}`);
        break;
      case('24_hours'):

        $dateSelect.find('option:selected').text(`Last 24 Hours: ${dateFormat(new Date(Date.now() - 86400000), 'ddd h:MM tt')} 
        - ${dateFormat(Date.now(), 'ddd h:MM tt')}`);
        break;
      case('12_hours'):

        $dateSelect.find('option:selected').text(`Last 12 Hours: ${dateFormat(new Date(Date.now() - 43200000), 'ddd h:MM tt')} 
        - ${dateFormat(Date.now(), 'ddd h:MM tt')}`);
        break;
      case('6_hours'):

        $dateSelect.find('option:selected').text(`Last 6 Hours: ${dateFormat(new Date(Date.now() - 21600000), 'ddd h:MM tt')} 
        - ${dateFormat(Date.now(), 'ddd h:MM tt')}`);
        break;
      case('yesterday'):
        $dateSelect.find('option:selected').text(`Yesterday: ${dateFormat(new Date(Date.now() - 86400000), 'mmm dd, yyyy')}`);
        break;
      case('this_week'):
        $dateSelect.find('option:selected').text(`This Week: Sun - ${dateFormat(new Date(Date.now()), 'ddd')}`);
        break;
      case('7_days'):
        $dateSelect.find('option:selected').text(
          `Last 7 Days: 
        ${dateFormat(new Date(Date.now() - 86400000 * 7), 'mmm dd')} - 
        ${dateFormat(new Date(Date.now()), 'mmm dd')}`);
        break;
      case('this_month'):
        $dateSelect.find('option:selected').text(`This Month: ${dateFormat(new Date(Date.now()), 'mmm')}`);
        break;
      case('last_month'):

        var d1 = new Date();
        d1.setDate(0);

        $dateSelect.find('option:selected').text(`Last Month: ${dateFormat(d1, 'mmm')}`);
        break;
      case('three_months'):

        var d1 = new Date();
        d1.setMonth(d1.getMonth() - 3);

        $dateSelect.find('option:selected').text(`Last Three Months: ${dateFormat(d1, 'mmm yyyy')} 
        to ${dateFormat(Date.now(), 'mmm yyyy')}`);
        break;
    }

  }

};

export default prettyDateSelect;
